// extracted by mini-css-extract-plugin
module.exports = {"content":"faq-view__content___crmeX"};